"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _propTypes = require("prop-types");

var _ToastAlert = _interopRequireDefault(require("./ToastAlert")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var ToastPortal = function ToastPortal(_ref) {
  var refToasterRoot = _ref.refToasterRoot,
      toastMap = _ref.toastMap,
      onRemoveToast = _ref.onRemoveToast;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _toConsumableArray2["default"])(toastMap.entries()).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        key = _ref3[0],
        toast = _ref3[1];

    return /*#__PURE__*/_react["default"].createElement(_ToastAlert["default"], (0, _extends2["default"])({
      key: key,
      mapKey: key,
      removeToast: onRemoveToast
    }, toast));
  })), refToasterRoot.current);
};

ToastPortal.propTypes = {
  refToasterRoot: _propTypes.object.isRequired,
  toastMap: (0, _propTypes.instanceOf)(Map).isRequired,
  onRemoveToast: _propTypes.func.isRequired
};
var _default = ToastPortal;
exports["default"] = _default;